import React from "react";
import StyledBubble from "./styles/StyledBubble";

const BubbleIcon = () => (
  <StyledBubble>
    <path
      d="M2.62074 16H1.34534L2.24718 15.0895C2.73344 14.5986 3.0371 13.9601 3.11873 13.2674C1.03637 11.8878 0 9.88917 0 7.79388C0 3.92832 3.51913 0 9.0305 0C14.8692 0 18 3.61479 18 7.45522C18 11.321 14.8361 14.9333 9.0305 14.9333C8.0135 14.9333 6.95226 14.7963 6.00478 14.5448C5.10787 15.4735 3.89262 16 2.62074 16Z"
      fill="#CDD2EE"
    />
  </StyledBubble>
);

export default BubbleIcon;
